import bathSvg from '../assets/bath.svg?raw';
import BathIcon from '../../../assets/icons/bath.svg?react';
import { defineSketchObjectType, registerSketchObjectType } from '../registry';
import { SketchObjectAnchorKind, SketchObjectCategory } from '../types';
import { t } from '../../translation/markers';

registerSketchObjectType(
  defineSketchObjectType({
    id: 'bath',
    label: t('Bath'),
    category: SketchObjectCategory.BATHROOM,
    anchor: SketchObjectAnchorKind.POINT,
    constraint: { kind: 'FREE' },
    defaultSize: { width: 1.7, depth: 0.75 },
    params: {},
    glyph: { kind: 'svg', assetKey: 'bath', svgSource: bathSvg },
    icon: BathIcon,
  }),
);
